import httpClient from '@/http-client'

export default {
  totalDealer() {
    return httpClient
      .get('/api/dashboard/total-dealers')
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
  },
  betting(Options = {}) {
    return httpClient
      .get('/api/dashboard/bettings', Options)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
  },
  balance() {
    return httpClient
      .get('/api/dashboard/balances')
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
  }
}
